import React from 'react';
import "./graph.css";

const SkeletonLoading = () => {
  return (
    <div className="skeleton-loading">
      <div className="skeleton-bar"></div>
      <div className="skeleton-bar"></div>
      <div className="skeleton-bar"></div>
      <div className="skeleton-bar"></div>
      <div className="skeleton-bar"></div>
    </div>
  );
};

export default SkeletonLoading;